import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import { toast } from "react-hot-toast";
import { persistor, store } from "./redux/store";
import { reset } from "./app/store/slice/counterSlice";

// ✅ REQUEST INTERCEPTOR - Attach token to every request
axios.interceptors.request.use(
  (config) => {
    const userData = sessionStorage.getItem("userData");

    if (userData) {
      try {
        const parsedData = JSON.parse(userData);
        const token = parsedData?.token;

        // console.log("Token in interceptor:", token);

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (e) {
        console.error("Failed to parse userData:", e);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// ✅ RESPONSE INTERCEPTOR - Handle 401 errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      console.log("Unauthorized - logging out");
      logoutHandler();
    }
    return Promise.reject(error);
  },
);

// ✅ LOGOUT HANDLER - Fixed to work outside React component
const logoutHandler = async () => {
  try {
    await signOut(auth);
    sessionStorage.clear();
    localStorage.clear();

    // Dispatch reset action
    store.dispatch(reset());

    toast.success("Logged out successfully");

    // Redirect to login
    window.location.href = "/login";
  } catch (error) {
    console.error("Logout error:", error);
    toast.error("Logout failed");
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);
